module.exports = __webpack_public_path__ + "img/selected3-min.22198a73.png";